<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">
			<top-nevleft></top-nevleft>
			
		 <b-col >
			<!-- <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Seller Dashboard</h5>
				</b-col>				
			</b-row> --> 
		
		<b-container fluid class="p-0 mt-2">
			<b-row class="mt-3 mb-2 m-0">
						<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
							<!--<h3>Manage Brands</h3> -->
						</b-col>
						<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
							<b-button variant="dark" pill class="mr-2" @click="showAddModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Coupon</b-button>
							
						</b-col>
					</b-row>
				
				<b-row class="m-0">
					<b-col class="col-md-12 col-sm-12 col-xs-12">
						<div class="container-box">
							<b-row class="mt-4 px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									<span class="ml-2">entries</span>
								</b-col>
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-3 pt-3">
								<b-col lg="12">
									<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
										<template v-slot:cell(price)="row">
											<span>{{row.value}}{{row.item.price_type==0?'%':'/-'}}</span>
										</template>
										
										<template v-slot:cell(apply_type)="row">
											<span v-if="row.value==0">Instant</span>
											<span v-if="row.value==1">After Pay</span>
											<span v-if="row.value==2">After Delivery</span>
											
										</template>
										
										<template v-slot:cell(start_at)="row">
										<span>{{$moment(row.value).format('DD-MM-YYYY')}}</span> to 
										<span>{{$moment(row.item.expired_at).format('DD-MM-YYYY')}}</span>
										
										</template>
										<!--<template v-slot:cell(actions)="row">
											<b-button pill variant="primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
											<b-button pill variant="danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
										</template> -->
										<template v-slot:cell(status)="row">
											<b-badge pill variant="success" v-if="row.value == 0">Active</b-badge>
											<b-badge pill variant="warning" v-else>In Active</b-badge>										
										</template>
										<template v-slot:cell(show_in_offer)="row">
											<b-badge pill variant="warning" v-if="row.value == 0">No</b-badge>
											<b-badge pill variant="success" v-else>Yes</b-badge>										
										</template>
										
										<template v-slot:cell(actions)="row">
											<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
											<!-- <b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button> -->
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
									<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
				
				
					<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Coupon':'Add Coupon'" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
						<form ref="form" @submit.stop.prevent="handleSubmit">
							<b-container fluid>
											<b-row class="mb-1">
											
												<b-col cols="12">
													<!--{{selectedItem}} -->
													
													
													<b-row class="mb-3">
														<b-col  class="text-right">
														<!-- <b-form-group label="Code" :state="selectedItemState.code"  label-for="brandName-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Brand name is required!" >
															<b-form-input v-model="selectedItem.code" size="sm" :maxlength="100" id="brandName-input" :state="selectedItemState.code" @focusin="selectedItemState.code = null" ></b-form-input>
														</b-form-group> -->
														
														<!--<b-input-group size="sm">
															
															<b-form-group label="Code" :state="selectedItemState.code"  label-for="brandName-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Brand name is required!" >
															<b-form-input v-model="selectedItem.code" size="sm" :maxlength="100" id="brandName-input" :state="selectedItemState.code" @focusin="selectedItemState.code = null" ></b-form-input>
														</b-form-group>

															<b-input-group-append>
															  
															  <b-input-group-text>
																  <b-icon icon="search"></b-icon>
															  </b-input-group-text>
															</b-input-group-append>
														  </b-input-group> -->
														  
														  
														  <b-form-group label="Code" :state="selectedItemState.code"  label-for="brandName-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Brand name is required!" >
															
															
															<b-input-group size="sm" class="mb-2" label="Code">
															
														 <!-- <b-form-input type="text" placeholder="Coupon Code"></b-form-input>-->
														  
														  <b-form-input v-model="selectedItem.code" size="sm" :maxlength="100" id="brandName-input" placeholder="Coupon Code" :state="selectedItemState.code" @focusin="selectedItemState.code = null" ></b-form-input>
														  
														  
														  
														  
														  
														  <b-input-group-append is-text>
															
															<i class="fa fa-refresh" aria-hidden="true" @click="generateCoupon"></i>
														  </b-input-group-append>
														</b-input-group>
															
															
														</b-form-group>
														  
														
																											
														
														</b-col>
														<b-col>
															<b-form-group label="Price" :state="selectedItemState.price"  label-for="price-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Price name is required!" >
																<b-form-input v-model="selectedItem.price" size="sm" :maxlength="100" id="price-input" :state="selectedItemState.price" @focusin="selectedItemState.price = null" ></b-form-input>
															</b-form-group>
														</b-col>
														<b-col>
															<b-form-group  label="Discount Type" :state="selectedItemState.price_type"  label-for="price_type-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="price_type is required!">
																<b-form-select v-model="selectedItem.price_type" id="price_type-input" :state="selectedItemState.price_type" v-on:change="selectedItemState.price_type = null" size="sm">
																<!--<b-form-select-option value="" hidden selected placeholder="Select Discount">*Select Discount</b-form-select-option> -->
																<b-form-select-option value="0">Percentage</b-form-select-option>
																<b-form-select-option value="1">Flat</b-form-select-option>
																</b-form-select>
															</b-form-group>
														</b-col>
														<b-col>
															
															<b-form-group label="QTY" :state="selectedItemState.code_qty"  label-for="code_qty-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="QTY is required!" >
																<b-form-input v-model="selectedItem.code_qty" size="sm" :maxlength="100" id="code_qty-input" :state="selectedItemState.code_qty" @focusin="selectedItemState.code_qty = null" ></b-form-input>
															</b-form-group>
															
														</b-col>
														
													</b-row>
													<b-row class="mb-3">
													<b-col  class="text-left">
														<b-form-group label="Start At" :state="selectedItemState.start_at"  label-for="start_at-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Start Date is required!" >
															<b-form-datepicker v-model="selectedItem.start_at" size="sm"  id="start_at-from" class="mb-2" placeholder="No date" :state="selectedItemState.start_at" @focusin="selectedItemState.start_at = null" :date-format-options="{ day: 'numeric',month: 'numeric', year: 'numeric'  }" ></b-form-datepicker>
														</b-form-group>
														
														
													</b-col>
													<b-col class="text-left">
														<b-form-group label="Expired At" :state="selectedItemState.expired_at"  label-for="expired_at-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Expired Date is required!" >
															<b-form-datepicker v-model="selectedItem.expired_at" size="sm"  id="expired_at-from" class="mb-2" placeholder="No date" :state="selectedItemState.expired_at" @focusin="selectedItemState.expired_at = null" :date-format-options="{ day: 'numeric',month: 'numeric', year: 'numeric'  }" ></b-form-datepicker>
														</b-form-group>
													</b-col>
													<b-col class="text-left">
															<b-form-group label="Apply on" :state="selectedItemState.apply_type"  label-for="apply_type-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Apply Type is required!">
																<b-form-select v-model="selectedItem.apply_type" id="apply_type-input" :state="selectedItemState.apply_type" v-on:change="selectedItemState.apply_type = null" size="sm">
																<b-form-select-option value="" hidden selected placeholder="select State">*Select Apply Type</b-form-select-option>
																<b-form-select-option value="0">Instant</b-form-select-option>
																<b-form-select-option value="1">After Pay</b-form-select-option>
																<b-form-select-option value="2">After Delivery	</b-form-select-option>
																</b-form-select>
															</b-form-group>
																
													</b-col>
													<b-col class="text-left">
															<b-form-group label="Status" :state="selectedItemState.status"  label-for="status-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Status is required!">
																<b-form-select v-model="selectedItem.status" id="status-input" :state="selectedItemState.status" v-on:change="selectedItemState.status = null" size="sm">
																<!--<b-form-select-option value="" hidden selected placeholder="select State">*Select status</b-form-select-option> -->
																<b-form-select-option value="0">Active</b-form-select-option>
																<b-form-select-option value="1">In Active</b-form-select-option>
																</b-form-select>
															</b-form-group>
													</b-col>
													</b-row>
													
													<b-row class="mb-3">
														
														
													</b-row>
													<b-row class="mb-3">
														<b-col>
															<!--<b-form-group label="Category" :state="selectedItemState.category"  label-for="category-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Category is required!" label-cols-sm="3" content-cols-sm >
																<b-form-select v-model="selectedItem.category"   id="category-input" :state="selectedItemState.category" v-on:change="selectedItemState.category = null" size="sm" :options="filteredCategory" >
																</b-form-select>
															</b-form-group> -->
															
															
															
															<b-form-group label="Category" :state="selectedItemState.category_id"  label-for="category-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="category is required!">
																<b-form-select v-model="selectedItem.category_id"   id="category-input" :state="selectedItemState.category_id" v-on:change="selectedItemState.category_id = null" size="sm" :options="filteredCategory" >
																<b-form-select-option value="null">All</b-form-select-option>
																</b-form-select>
															</b-form-group> 
															
															
														</b-col>
														<b-col>
															<b-form-group label="About Coupon" :state="selectedItemState.details"  label-for="details-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="About Coupon is required!">
														
														
															<b-form-textarea id="details-input" v-model="selectedItem.details" size="sm" rows="3" :maxlength="250" required></b-form-textarea>
															<small class="float-right" v-if="selectedItem.details!=null">		{{250-selectedItem.details.length}}/250 Character Remaining</small>	
															</b-form-group>
														</b-col>
													</b-row>
													
													
													
													
													
												</b-col>
											</b-row>

								
							</b-container>
						</form>
						<template v-slot:modal-footer="{ ok, close }">
							<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
							<!-- <b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>-->
							<b-button size="sm" variant="success" @click="modalSubmit">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
						</template>
					</b-modal>	
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
			<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
	
	</div>
	
</template>
<script>
import '@/assets/profileuser.scss';
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Footer from "@/components/footer-admin.vue";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		
	},
	mounted(){
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
		
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'couponapi/coupon-record',
			//insertUrl: this.$root.WEBAPI+'sellerapi/brand-insert',
			insertUrl: this.$root.WEBAPI+'couponapi/coupon-insert',
			updateUrl: this.$root.WEBAPI+'couponapi/coupon-update',
			deleteUrl: this.$root.WEBAPI+'couponapi/coupon-delete',
			csvgenUrl: this.$root.WEBAPI+'sellerapi/product-csvgen',
			filteredCategory: [],
			optionsSel:[],
			category: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Brands',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'code', label: 'Code'},				
				{ key: 'price', label: 'Price'},				
				//{ key: 'price_type', label: 'Price Type'},				
				{ key: 'code_qty', label: 'Qty'},				
				{ key: 'details', label: 'Description'},
				{ key: 'apply_type', label: 'Apply Type' },
				{ key: 'start_at', label: 'Validated' },
				{ key: 'status', label: 'Status' },
				{ key: 'show_in_offer', label: 'Show in Offer' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				code: '',
				price: '',
				price_type: 0,
				code_qty: '',
				details: '',
				apply_type:0,
				start_at: '',
				expired_at: '',
				status: '',
				short_description: '',
				product_data:{}, 
				tier_price:[], 
				gallery_images:[""],
				category_id:null
			},
			selectedItemState: {
				code:null,
				price:null,
				price_type:null,
				code_qty:null,
				details:null,
				apply_type:null,
				start_at:null,
				expired_at:null,
				status:null,
				category_id:null
				
			},
			emptyItem: {
				id: 0,
				code: '',
				price: '',
				price_type:0,
				code_qty: '',
				details: '',
				apply_type:0,
				start_at:'',
				expired_at:'',
				status:0,
				category_id:null
			},
			counterindex:1
		};
	},
	methods: {		
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			console.log('asdasds'+item);
			
			this.selectedItem = Object.assign({}, item);
			
			if(item.product_data){
				this.selectedItem.product_data = JSON.parse(item.product_data);
			}
			if(item.tier_price){
				this.selectedItem.tier_price = JSON.parse(item.tier_price);
			}
			
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showCsvModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to generate product csv!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.csvgenUrl, {
						accesskey: self.$session.get('access_key'),
						product_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){

							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Brand!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var valid = true;
			
			if(this.selectedItem.price=='') {
				this.selectedItemState.price = false;
				valid = false;
			}else this.selectedItemState.price = true;
			
			
			
			/* if(this.selectedItem.price_type=='') {
				this.selectedItemState.price_type = false;
				valid = false;
			}else this.selectedItemState.price_type = true; */
			
			if(this.selectedItem.code_qty=='') {
				this.selectedItemState.code_qty = false;
				valid = false;
			}else this.selectedItemState.code_qty = true;
			
			if(this.selectedItem.apply_type==''){
				this.selectedItemState.apply_type = false;
				valid = false;
			}else this.selectedItemState.apply_type = true;
			
			/* if(this.selectedItem.status=='') {
				this.selectedItemState.status = false;
				valid = false;
			}else this.selectedItemState.status = true; */
			
			if(this.selectedItem.start_at=='') {
				this.selectedItemState.start_at = false;
				valid = false;
			}else this.selectedItemState.start_at = true;
		
		
			if(valid){
				var self = this;
				self.loading = true;
				bvModalEvt.preventDefault();
				var submitUrl = "";
				if(self.selectedItem.id == 0){
					submitUrl = self.insertUrl;
				}else{
					submitUrl = self.updateUrl;
				}

				let formData = new FormData();
				/*formData.append('imagefile1', this.product_inf.product_image_1);
				formData.append('imagefile2', this.product_inf.product_image_2);
				formData.append('imagefile3', this.product_inf.product_image_3);
				formData.append('imagefile4', this.product_inf.product_image_4);*/
				formData.append('data', JSON.stringify(this.selectedItem));
				formData.append('accesskey', this.$session.get('access_key'));

				self.axios.post(submitUrl, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('my-model');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
						self.product_inf.product_image_1 = '';
						self.selectedItemState={
							brand_name:null,
							about_brand:null,
							status:null,
						},
						
						self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			
			}
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					console.log(self.records);
					self.category = response.data.result.category; 
					self.loading = false;
					self.totalRows = self.records.length;

					self.filteredCategory = [];
					self.filterChildCategory(0, 0, 0);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		generateCoupon() {
			var len =8;
			 //var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			 var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
			var codeVAl = [...Array(len)].reduce(a=>a+p[~~(Math.random()*p.length)],'');
			this.selectedItem.code = codeVAl;
			
		},
		filterChildCategory(id, index, parentid){
			var self = this;
			var tab = '';
			for (let i = 0; i < index; i++) {
				tab += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
			}
			this.category.forEach(function(field){
				if(field.parent == id){
					var fieldid = field.id;
					if(parentid != 0){
						fieldid = parentid+','+field.id;
					}
					self.filteredCategory.push({ html: tab+field.title, title:field.title, position:field.position, parent:field.parent, value: fieldid });
					
					self.optionsSel.push({ name: tab+field.title, language:field.title,value: fieldid});
					
					self.filterChildCategory(field.id, index+1, fieldid);
				}
			});
			return ;
		},
	}
}
</script>
<style>
</style>